<div class="duplicate-warning">
	<p>The following {{tickets[0].ticketMode!}} appear to be duplicates:</p>

	<ul>
		<li *ngFor="let t of tickets" (click)="openTicket(t)" class="ticket-link">
			{{ t.createdAt! | date }} :
			<strong>{{ t.ticketReference }}</strong>
		</li>
	</ul>

	<p>Please confirm if you want to continue.</p>

	<div class="footer">
		<button nz-button nzType="default" (click)="cancel()">Cancel</button>
		<button nz-button nzType="primary" (click)="continue()">Continue</button>
	</div>
</div>
